import { render, staticRenderFns } from "./SpotlightFooter.vue?vue&type=template&id=2dea2f6c&scoped=true"
import script from "./SpotlightFooter.vue?vue&type=script&lang=js"
export * from "./SpotlightFooter.vue?vue&type=script&lang=js"
import style0 from "./SpotlightFooter.vue?vue&type=style&index=0&id=2dea2f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea2f6c",
  null
  
)

export default component.exports